import { Anchor, AnchorProps } from 'antd';
import { ReactNode } from 'react';
import Styles from './index.module.scss';

const { Link } = Anchor;

interface IDataItem {
  href: string;
  target?: string;
  title: ReactNode;
}

interface IProps extends AnchorProps {
  affix?: boolean;
  offsetTop?: number;
  data: IDataItem[];
}

const MyAnchor = ({ affix = true, offsetTop = 80, data, ...props }: IProps) => {
  return (
    <Anchor
      affix={affix}
      offsetTop={offsetTop}
      {...props}
      className={Styles.anchor}
    >
      {data.map((item) => (
        <Link key={item.href} {...item} />
      ))}
    </Anchor>
  );
};

export default MyAnchor;
